import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NavigationService } from './core/layout/nav/navigation.service';
import { AuthService } from './core/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  title = 'frontend';

  // Inject NavigationService to manage navigation visibility
  constructor(
    public navService: NavigationService,
    public authService: AuthService
  ) {}
}
